import { Box, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import sigliveEmpty from 'Asset/image/siglive-empty-state.svg';
import { PlusIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import ButtonSolid from 'UiKit/button/buttonSolid';
import { TextBold, TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const EmptyState = ({ title = '', description = '', actionText = '', icon = sigliveEmpty, onAction, className, background, height, isCanCreate }) => {
  const { t } = useTranslation('empty-state');

  return (
    <Box className={`${styles['empty-state__container']} ${className}`} background={background} height={height}>
      <Box className={styles['empty-state__content']}>
        <Box className={styles['empty-state__icon-wrapper']}>
          <Image src={icon} alt="Empty state" />
        </Box>

        <TextBold className={styles['empty-state__title']}>{title || t('no_data.title')}</TextBold>
        <TextRegular className={styles['empty-state__description']}>{description || t('no_data.description')}</TextRegular>

        <Condition statement={onAction && isCanCreate}>
          <ButtonSolid onClick={onAction} className={styles['empty-state__action-button']} gap="8px">
            <PlusIcon size="18px" />
            {actionText}
          </ButtonSolid>
        </Condition>
      </Box>
    </Box>
  );
};

export default EmptyState;
